import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxSessionAttachmentsPopoverComponent } from '@go-modules/components/feedback-session/session-attachments-popover/session-attachments-popover.component';

// TODO - remove when feedbackSession ngx STAB-680
export const ngxSessionAttachmentsPopoverModule = angular.module('ngxSessionAttachmentsPopoverModule', [])
	.directive('ngxSessionAttachmentsPopover', downgradeComponent({ component: NgxSessionAttachmentsPopoverComponent }))
	.name;
